import Axios from 'axios';
import { baseUrl } from '../config/serviceConfig';

const PostFormData = (path, data, token) => {
    return Axios({
        method: 'POST',
        url: baseUrl + path,
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': token
        }
    })
}

export default PostFormData;